/*
 * @创建文件时间: 2021-06-01 22:41:21
 * @Auther: 猿小天
 * @最后修改人: 猿小天
 * @最后修改时间: 2021-11-19 21:49:43
 * 联系Qq:1638245306
 * @文件介绍:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast, Dialog } from 'vant'
import clientConfig from '@/config/clientConfig'
Vue.use(Toast)
import session from '@/utils/session'
import store from '@/store/index'
import util from '@/libs/util.js'
import * as api from '@/api/modules/sys.js'
import {
   SYS_USER_LOGIN,
   SYS_USER_LOGOUT,
   reform_id_user_id,
   update_user_info,
} from '@/views/login/api'
import auth from '@/utils/auth' // 导入Token管理服务
// 路由数据
import routes from './routes'
// import { getMenu, handleAsideMenu, handleRouter, checkRouter } from '@/menu'

// 常量定义
const ERROR_MESSAGES = {
   NON_WECHAT: '不允许在非企微环境使用!',
   USER_INFO_FAILED: '获取用户信息失败!',
}

const env = process.env.NODE_ENV
console.log(env, 'envenvenvenvenvenvenv')
// 工具函数
const utils = {
   /**
    * 验证环境
    * @param {string} clientName - 客户端名称
    * @returns {boolean} - 环境是否有效
    */
   validateEnvironment(clientName) {
      if (
         !util.isWeChatWorkEnv() &&
         clientName != 'zhenhan' &&
         env != 'development'
      ) {
         debugger
         Toast.fail(ERROR_MESSAGES.NON_WECHAT)
         return false
      }
      return true
   },

   /**
    * 处理用户信息缓存
    * @returns {Object|null} - 缓存的用户信息
    */
   getCachedUserInfo() {
      const userInfo = util.localStorage.get('userInfo')
      if (userInfo) {
         const parsedInfo = JSON.parse(userInfo)
         if (parsedInfo.origin === window.top.origin && parsedInfo.userid) {
            return parsedInfo
         }
      }
      return null
   },

   /**
    * 初始化授权流程 - 优化版，使用客户端配置
    * @param {string} code - 授权码
    * @param {Object} query - 路由查询参数
    */
   async initializeAuth(code, query) {
      // 这个方法现在空实现，因为逻辑已移到路由拦截器中
      console.log('initializeAuth 方法已弃用，授权初始化已集成到路由拦截器中')
   },

   /**
    * 处理新用户登录 - 优化版，不再重复获取token
    * @param {string} code - 授权码
    * @param {string} clientId - 客户端ID
    * @returns {Promise<Object>} - 登录结果，包含是否成功和用户基本信息
    */
   async handleNewUserLogin(code, clientId) {
      try {
         console.log('开始登录流程，参数：', { code, clientId })

         // 检查是否有有效的登录缓存
         if (
            util.userLoginCache.hasValidCache() &&
            util.userLoginCache.validateCachedInfo()
         ) {
            // 存在有效缓存，直接使用
            console.log('发现有效的登录缓存，使用缓存数据')
            const cachedInfo = util.userLoginCache.getLoginInfo()

            // 从缓存恢复状态
            util.cookies.set('userid', cachedInfo.userid)
            util.localStorage.set(
               'userInfo',
               JSON.stringify({
                  userid: cachedInfo.userid,
                  origin: window.top.location.origin,
               })
            )

            // 更新Vuex store
            await store.dispatch(
               'tccc/user/set',
               {
                  ...cachedInfo,
                  userid: cachedInfo.userid,
                  primitiveUserid: cachedInfo.primitiveUserid,
               },
               { root: true }
            )

            return {
               success: true,
               userInfo: {
                  userid: cachedInfo.userid,
                  full_name: cachedInfo.full_name || '',
               },
            }
         }

         // 无缓存或缓存无效，执行正常登录流程
         console.log('无有效登录缓存，执行正常登录流程')

         // 1. 确保认证头部已设置
         console.log('确保认证头部设置...')
         const headers = await auth.ensureAuthHeaders()
         console.log('认证头部已就绪:', Object.keys(headers))

         // 2. 用户登录
         console.log('开始调用登录接口...')
         const loginResult = await SYS_USER_LOGIN({
            ad_uid: '',
            client_id: clientId,
            data: { code },
         })
         console.log('登录接口返回:', loginResult)

         if (loginResult.status_code === 0 && loginResult.data?.userid) {
            // 3. 获取编码后的userid
            console.log('开始获取编码后的userid...')
            const reformResult = await reform_id_user_id({
               ad_uid: '',
               client_id: clientId,
               user_id: loginResult.data.userid,
            })
            console.log('reform_id_user_id返回:', reformResult)

            if (reformResult.status_code === 0 && reformResult.data) {
               // 4. 保存用户信息
               const userInfo = {
                  userid: reformResult.data,
                  origin: window.top.location.origin,
               }
               util.cookies.set('userid', reformResult.data)
               util.localStorage.set('userInfo', JSON.stringify(userInfo))

               // 5. 更新 Vuex store
               await store.dispatch(
                  'tccc/user/set',
                  {
                     ...loginResult.data,
                     userid: reformResult.data,
                     primitiveUserid: loginResult.data.userid,
                  },
                  { root: true }
               )

               // 6. 缓存登录信息
               util.userLoginCache.saveLoginInfo({
                  ...loginResult.data,
                  userid: reformResult.data,
                  primitiveUserid: loginResult.data.userid,
                  origin: window.top.location.origin,
               })

               // 7. 异步更新用户详细信息
               console.log('异步更新用户详细信息...')
               update_user_info({
                  ad_uid: '',
                  client_id: clientId,
                  data: {
                     user_id: reformResult.data,
                     username: loginResult.data.full_name,
                     email: loginResult.data.email,
                     mobile: loginResult.data.mobile,
                  },
               }).catch((error) => {
                  console.error('更新用户信息失败:', error)
               })

               return {
                  success: true,
                  userInfo: {
                     userid: reformResult.data,
                     full_name: loginResult.data.full_name,
                  },
               }
            }
         } else {
            console.error('登录接口返回异常:', loginResult)
            throw new Error(`登录失败: ${loginResult.message || '未知错误'}`)
         }
      } catch (error) {
         console.error('登录流程失败，详细错误:', error)
         console.error('错误堆栈:', error.stack)
         return { success: false, error }
      }
   },
}

// fix vue-router NavigationDuplicated
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return VueRouterPush.call(this, location).catch((err) => err)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
   return VueRouterReplace.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
   base: '/h5/',
   routes,
   mode: 'history',
})

/**
 * 路由拦截 - 整合 session_key 管理
 * 权限验证与页面加载优化
 */
router.beforeEach(async (to, from, next) => {
   // 添加性能计时
   const routerStartTime = performance.now()
   console.log('⏱️ [路由拦截器] 开始执行:', new Date().toISOString())

   // 设置 loading 状态
   store.dispatch('tccc/app/setLoading', true, { root: true })
   store.dispatch('tccc/app/setLoadingText', '加载中...', { root: true })

   try {
      // 1. 环境检查 - 必要操作
      const envStartTime = performance.now()
      if (!utils.validateEnvironment(process.env.VUE_APP_CLIENT_NAME)) {
         store.dispatch('tccc/app/setLoading', false, { root: true })
         return
      }
      console.log(
         `⏱️ [路由拦截器] 环境检查完成: ${(performance.now() - envStartTime).toFixed(2)}ms`
      )

      // 2. 确保数据已加载
      await store.dispatch('tccc/page/isLoaded')
      console.log(
         `⏱️ [路由拦截器] 数据加载检查触发: ${(performance.now() - routerStartTime).toFixed(2)}ms`
      )

      // 3. 处理用户授权和登录流程
      if (to.query.code) {
         // 有授权码，执行标准登录流程
         console.log('⏱️ [路由拦截器] 检测到授权码，开始处理登录流程')

         try {
            // 初始化Token和配置
            const tokenStartTime = performance.now()
            console.log('⏱️ [路由拦截器] 初始化Token和配置开始')

            console.log('解码前的client_id:', to.query.client_id)
            const clientId = atob(window.decodeURI(to.query.client_id))
            console.log('解码后的client_id:', clientId)
            // 设置客户端信息
            await store.dispatch(
               'tccc/client/set',
               { client_id: clientId },
               { root: true }
            )
            util.localStorage.set('client_id', clientId)
            console.log(
               `⏱️ [路由拦截器] 客户端信息设置完成: ${(performance.now() - tokenStartTime).toFixed(2)}ms`
            )

            // 设置授权码信息
            store.dispatch('tccc/login/set', to.query.code, { root: true })

            // 获取配置信息
            store
               .dispatch('tccc/configuration/get_config_json', to.query)
               .catch((err) =>
                  console.error('配置获取失败，将在进入页面后重试', err)
               )

            // 处理用户登录 - 使用现有的用户登录流程获取用户基本信息
            const loginStartTime = performance.now()
            const loginResult = await utils.handleNewUserLogin(
               to.query.code,
               clientId
            )
            console.log(
               `⏱️ [路由拦截器] 登录处理完成: ${(performance.now() - loginStartTime).toFixed(2)}ms, 结果: ${loginResult.success ? '成功' : '失败'}`
            )

            // 用户登录成功后等待初始化 session_key
            if (loginResult.success && loginResult.userInfo?.userid) {
               try {
                  // 保存 user_id 到本地，session.js 需要用它获取 session_key
                  util.localStorage.set('user_id', loginResult.userInfo.userid)

                  // 检查session_key状态并获取
                  store.dispatch(
                     'tccc/app/setLoadingText',
                     '初始化会话凭证...',
                     { root: true }
                  )
                  const sessionStartTime = performance.now()
                  const sessionResult = await session.refreshSessionKey()
                  console.log(
                     `⏱️ [路由拦截器] session_key 获取完成: ${(performance.now() - sessionStartTime).toFixed(2)}ms, 结果: ${sessionResult ? '成功' : '失败'}`
                  )

                  if (!sessionResult) {
                     throw new Error('无法获取有效会话凭证')
                  }

                  // 启动主动检查定时器，每3分钟检查一次
                  session.startSessionCheckTimer(3 * 60 * 1000)
               } catch (sessionError) {
                  console.error(
                     '⏱️ [路由拦截器] 初始化 session_key 失败:',
                     sessionError
                  )
                  Toast.fail('会话初始化失败，某些功能可能无法使用')
                  // 即使失败也继续，但给用户提示
               }
            }
         } catch (error) {
            console.error('⏱️ [路由拦截器] 登录流程错误:', error)
            Toast.fail(error.message || '用户信息获取失败')
         }
      } else {
         // 无授权码，尝试使用缓存登录
         console.log('⏱️ [路由拦截器] 无授权码，检查登录缓存')

         // 检查是否有有效缓存
         const cacheStartTime = performance.now()
         const hasValidCache = util.userLoginCache.hasValidCache()
         console.log(
            `⏱️ [路由拦截器] 缓存检查完成: ${(performance.now() - cacheStartTime).toFixed(2)}ms, 有效缓存: ${hasValidCache}`
         )

         if (hasValidCache) {
            console.log('⏱️ [路由拦截器] 发现有效的登录缓存')

            // 从缓存恢复登录状态
            const clientId = util.localStorage.get('client_id')
            if (clientId) {
               const loginStartTime = performance.now()
               const loginResult = await utils.handleNewUserLogin(
                  null,
                  clientId
               )
               console.log(
                  `⏱️ [路由拦截器] 缓存登录完成: ${(performance.now() - loginStartTime).toFixed(2)}ms, 结果: ${loginResult.success ? '成功' : '失败'}`
               )

               // 缓存登录成功后，确保有有效的 session_key
               if (loginResult.success && loginResult.userInfo?.userid) {
                  // 检查 session_key 是否有效
                  console.log('⏱️ [路由拦截器] 开始检查session_key状态')

                  // 先记录当前session_key状态
                  const session_key = util.localStorage.get('session_key')
                  const expires_time = util.localStorage.get(
                     'session_key_expires_time'
                  )

                  if (session_key && expires_time) {
                     const now = new Date().getTime()
                     const expireTime = new Date(expires_time).getTime()
                     const remainingTimeMs = expireTime - now
                     const remainingMinutes = Math.floor(
                        remainingTimeMs / (60 * 1000)
                     )
                     const remainingHours = Math.floor(remainingMinutes / 60)
                     const remainingMins = remainingMinutes % 60

                     console.log(
                        `⏱️ [路由拦截器] 缓存中的session_key信息 - ` +
                           `状态: ${remainingTimeMs > 0 ? '有效' : '已过期'}, ` +
                           `剩余时间: ${remainingHours}小时${remainingMins}分钟, ` +
                           `session_key: ${session_key.substr(0, 10)}...`
                     )
                  } else {
                     console.log('⏱️ [路由拦截器] 缓存中没有session_key信息')
                  }

                  const sessionCheckStartTime = performance.now()
                  const isSessionValid = session.isSessionKeyValid()
                  console.log(
                     `⏱️ [路由拦截器] session_key有效性检查: ${(performance.now() - sessionCheckStartTime).toFixed(2)}ms, 结果: ${isSessionValid ? '有效' : '无效或即将过期'}`
                  )

                  if (!isSessionValid) {
                     try {
                        console.log(
                           '⏱️ [路由拦截器] session_key无效或即将过期，开始刷新'
                        )
                        // *** 关键修改：等待获取 session_key 完成 ***
                        store.dispatch(
                           'tccc/app/setLoadingText',
                           '初始化会话凭证...',
                           { root: true }
                        )
                        const sessionStartTime = performance.now()
                        const sessionResult = await session.refreshSessionKey()
                        console.log(
                           `⏱️ [路由拦截器] session_key刷新完成: ${(performance.now() - sessionStartTime).toFixed(2)}ms, 结果:`,
                           sessionResult ? '成功' : '失败',
                           sessionResult?.session_key
                              ? `新session_key: ${sessionResult.session_key.substr(0, 10)}...`
                              : ''
                        )
                     } catch (sessionError) {
                        console.error(
                           '⏱️ [路由拦截器] 刷新 session_key 失败:',
                           sessionError
                        )
                        Toast.fail('会话初始化失败，某些功能可能无法使用')
                        // 即使失败也继续，但给用户提示
                     }
                  } else {
                     console.log(
                        '⏱️ [路由拦截器] 本地已有有效的 session_key，无需刷新'
                     )
                  }
               }
            }
         } else {
            // 检查是否有过期但仍存在的缓存
            const hasExpiredCache =
               util.userLoginCache.hasExpiredButExistingCache()
            console.log(
               `⏱️ [路由拦截器] 检查是否有过期缓存: ${hasExpiredCache}`
            )

            if (hasExpiredCache) {
               console.log('⏱️ [路由拦截器] 发现过期的登录缓存，尝试自动续期')

               // 获取客户端ID
               const clientId = util.localStorage.get('client_id')

               if (clientId) {
                  // 自动续期
                  const renewStartTime = performance.now()
                  const renewSuccess = util.userLoginCache.renewCache()
                  console.log(
                     `⏱️ [路由拦截器] 缓存续期尝试: ${(performance.now() - renewStartTime).toFixed(2)}ms, 结果: ${renewSuccess ? '成功' : '失败'}`
                  )

                  if (renewSuccess) {
                     console.log(
                        '⏱️ [路由拦截器] 缓存续期成功，继续使用当前登录状态'
                     )

                     // 使用续期后的缓存恢复登录状态
                     const loginStartTime = performance.now()
                     const loginResult = await utils.handleNewUserLogin(
                        null,
                        clientId
                     )
                     console.log(
                        `⏱️ [路由拦截器] 续期后缓存登录: ${(performance.now() - loginStartTime).toFixed(2)}ms, 结果: ${loginResult.success ? '成功' : '失败'}`
                     )

                     // 检查 session_key 状态
                     if (loginResult.success) {
                        // 同上，检查并刷新 session_key
                        const sessionCheckStartTime = performance.now()
                        const isSessionValid = session.isSessionKeyValid()
                        console.log(
                           `⏱️ [路由拦截器] session_key有效性检查: ${(performance.now() - sessionCheckStartTime).toFixed(2)}ms, 结果: ${isSessionValid ? '有效' : '无效或即将过期'}`
                        )

                        if (!isSessionValid) {
                           // *** 关键修改：等待获取 session_key 完成 ***
                           try {
                              store.dispatch(
                                 'tccc/app/setLoadingText',
                                 '初始化会话凭证...',
                                 { root: true }
                              )
                              const sessionStartTime = performance.now()
                              await session.refreshSessionKey()
                              console.log(
                                 `⏱️ [路由拦截器] session_key刷新完成: ${(performance.now() - sessionStartTime).toFixed(2)}ms`
                              )
                           } catch (err) {
                              console.error(
                                 '⏱️ [路由拦截器] 刷新 session_key 失败:',
                                 err
                              )
                              Toast.fail('会话初始化失败，某些功能可能无法使用')
                           }
                        }
                     }
                  } else {
                     console.error('⏱️ [路由拦截器] 缓存续期失败')
                  }
               }
            } else {
               console.log(
                  '⏱️ [路由拦截器] 没有有效的登录缓存，但检查 session_key 是否有效'
               )

               // 检查是否已有 user_id 和有效的 session_key
               // 某些场景下可能已经有用户信息但 userLoginCache 未存储
               const user_id =
                  util.localStorage.get('user_id') || util.cookies.get('userid')
               if (user_id) {
                  const sessionCheckStartTime = performance.now()
                  const isSessionValid = session.isSessionKeyValid()
                  console.log(
                     `⏱️ [路由拦截器] session_key有效性检查: ${(performance.now() - sessionCheckStartTime).toFixed(2)}ms, 结果: ${isSessionValid ? '有效' : '无效或即将过期'}`
                  )

                  if (!isSessionValid) {
                     // 有 user_id 但 session_key 无效，等待刷新
                     try {
                        // *** 关键修改：等待获取 session_key 完成 ***
                        store.dispatch(
                           'tccc/app/setLoadingText',
                           '初始化会话凭证...',
                           { root: true }
                        )
                        const sessionStartTime = performance.now()
                        await session.refreshSessionKey()
                        console.log(
                           `⏱️ [路由拦截器] session_key刷新完成: ${(performance.now() - sessionStartTime).toFixed(2)}ms`
                        )
                     } catch (err) {
                        console.warn(
                           '⏱️ [路由拦截器] 刷新 session_key 失败:',
                           err
                        )
                        Toast.fail('会话初始化失败，某些功能可能无法使用')
                     }
                  }
               }
            }
         }
      }

      // 路由导航继续
      console.log(
         `⏱️ [路由拦截器] 处理完成，准备导航: ${(performance.now() - routerStartTime).toFixed(2)}ms`
      )
      next()
   } catch (error) {
      console.error('⏱️ [路由拦截器] 错误', error)
      Toast({
         type: 'fail',
         message: error.message || '用户信息获取失败',
         duration: 3000,
      })
      next()
   }
})

router.afterEach((to) => {
   // 记录路由完成时间
   console.log(
      `⏱️ [路由完成] 路由导航完成: ${to.path}, 时间: ${new Date().toISOString()}`
   )

   // 更改标题
   util.title(to.meta.title)

   // 延迟关闭 loading，确保页面内容已经渲染
   setTimeout(() => {
      store.dispatch('tccc/app/setLoading', false, { root: true })
   }, 300)
})

export default router
